var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_288_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H5.625C2.5184 0 0 2.5184 0 5.625V18.375C0 21.4816 2.5184 24 5.625 24H18.375C21.4816 24 24 21.4816 24 18.375V5.625C24 2.5184 21.4816 0 18.375 0Z",
    fill: "#F4F2ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78125 10.3125C8.34375 8.0625 9.75009 6.9375 12 6.9375C15.375 6.9375 15.7969 9.46875 17.4844 9.89062C18.6095 10.172 19.5938 9.75009 20.4375 8.625C19.8751 10.8749 18.4687 12 16.2188 12C12.8438 12 12.4219 9.46875 10.7344 9.04688C9.60928 8.76562 8.625 9.1875 7.78125 10.3125ZM3.5625 15.375C4.125 13.1251 5.53125 12 7.78125 12C11.1562 12 11.5781 14.5312 13.2656 14.9531C14.3907 15.2345 15.375 14.8126 16.2188 13.6875C15.6563 15.9374 14.2499 17.0625 12 17.0625C8.625 17.0625 8.20312 14.5312 6.51562 14.1094C5.39062 13.828 4.40625 14.2499 3.5625 15.375Z",
    fill: "url(#paint0_linear_288_43)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_288_43",
    x1: 8.10937,
    y1: 6.9375,
    x2: 15.3281,
    y2: 17.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14C6B7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_288_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.a8b7c253e6185761105beb274694a9a1.svg";
export { ForwardRef as ReactComponent };